import { useState } from "react";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { SearchInputField } from "../../components/generic/searchInputField.component";
import { AddSuperAdminButton } from "../../components/superAdmin/AddNewButton.component";
import { SuperAdminTable } from "../../components/superAdmin/ListTable.component";

export const SuperAdminList = () => {
  const [searchKey, setSearchKey] = useState<string>("");
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header">
            Super Admin <BreadCrumbSign /> List
          </p>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <AddSuperAdminButton />
            <SearchInputField
              searchKey={searchKey}
              setSearchKey={setSearchKey}
            />
          </div>
          <SuperAdminTable searchKey={searchKey}/>
        </div>
      </div>
    </div>
  );
};
